import { I18n, createI18n } from 'vue-i18n';
import { replaceLocaleByOem } from '@/util/system';

function getSupportedLangs() {
    return supportedLangs;
}

// 语言格式处理
function formatCurrentLang(lang: string) {
    const lowerCaseLang = lang.toLowerCase();

    // 处理 语言-地区 格式
    if (lowerCaseLang.includes('-')) {
        const preLang = lowerCaseLang.split('-')[0];

        if (preLang !== 'zh') {
            return preLang;
        }
    }

    return lowerCaseLang;
}

// 获取当前要使用的语言
function getCurrentLang() {
    // 获取浏览器语言
    const browserLang = navigator.language;

    let resultLang = 'en';

    const supportedLangs: Record<any, any> = getSupportedLangs();

    resultLang = formatCurrentLang(browserLang);

    // 注意这边已经不是浏览器语言名字是语言文件名字
    return {
        lang: resultLang,
        langFileName: supportedLangs.hasOwnProperty(resultLang) ? supportedLangs[resultLang] : 'en'
    };
}

/**
 * 更改 vue-i18n 的语言
 * @param i18n vue-i18n 对象
 * @param locale 目标语言
 */
export async function changeLocale(i18n: I18n, locale: string) {
    if (i18n.mode === 'legacy' || typeof i18n.global.locale === 'string') {
        i18n.global.locale = locale;
    } else {
        (i18n.global.locale as any).value = locale;
    }
	document.querySelector('html')?.setAttribute('lang', locale);

	// 加载未加载过的语言
	if (!i18n.global.availableLocales.includes(locale)) {
	    const messages = await loadLocaleMessages(locale);
	    i18n.global.setLocaleMessage(locale, messages);
	}
}

/**
 * 加载对应语言的词条
 * @param locale 目标语言
 * @returns 目标语言的词条对象
 */
async function loadLocaleMessages(locale: string) {
    try {
        // 动态 import 词条文件
        const messages = await import(/* webpackChunkName: "locale-[request]" */ `./lang/${locale}.ts`);
        return messages.default.i18n;
    } catch (error) {
        console.error(`Failed to load locale messages for ${locale}:`, error);
        const enLocale = 'en';
        const enMessages = await import(/* webpackChunkName: "locale-[request]" */ `./lang/${enLocale}.ts`);
        return enMessages.default.i18n;
    }
}

const { lang, langFileName } = getCurrentLang();

// 注册i8n实例并引入语言文件
const i18n = createI18n({
    legacy: false,
    locale: langFileName,
    fallbackLocale: 'en',
    formatFallbackMessages: true,
    messages: {
        // 预加载默认语言的词条文件
        [langFileName]: {}
    },
    postTranslation: (translated: unknown) => replaceLocaleByOem(translated as string)
});
const $t = i18n.global.t;

// 加载错误码的词条
loadErrorCodeLocale();

async function loadErrorCodeLocale() {
    // 动态 import 词条文件
    const messages = await import(
        /* webpackChunkName: "locale-error-code" */ `./lang/${langFileName}-error-code.ts`
    );

    i18n.global.mergeLocaleMessage(langFileName, { errorCode: messages.default.i18n });
}

export default i18n;
export { $t };
